export default [
  {
    path: window.pathApp + '/:slug',
    name: 'evento',
    component: () => import('@/components/Evento'),
    meta: {
      login: true,
      title: "Evento",
    },
  },
  {
    path: window.pathApp + '/votacao/:slug/:hash?',
    name: 'deliberacoes',
    component: () => import('./../../../../deliberacoes/src/components/Deliberacoes'),
    meta: {
      login: true,
      title: "Deliberações",
    }
  },
  {
      path: "*",
      redirect: {
        name: 'evento',
        params: {
          'slug': 'no-event'
        }
      },
  },
]



// WEBPACK FOOTER //
// ./src/router/routes/evento.js